import { Box } from "@chakra-ui/layout";
import { useEffect } from "react";
import { ChatState } from "../Context/ChatProvider";
import SingleChat from "./SingleChat";
import { reorderChats } from "../utils/chatHelpers";
import socket from "../socket";

const Chatbox = ({ fetchAgain, setFetchAgain }) => {
  const { selectedChat, chats, setChats, user, setMessages, setUnreadCounts } =
    ChatState();

  useEffect(() => {
    if (!socket.connected) socket.connect();

    socket.emit("setup", user);
    socket.emit("user active", user._id);
    socket.emit("join user room", user._id);

    socket.on("message received", (newMessage) => {
      const chatId = String(newMessage.chat._id || newMessage.chat);
      const selectedId = String(selectedChat?._id || "");

      if (chatId === selectedId) {
        setMessages((prev) => [...prev, newMessage]);
        setChats((prevChats) => reorderChats(prevChats, newMessage));
      } else {
        setUnreadCounts((prev) => ({
          ...prev,
          [chatId]: (prev[chatId] || 0) + 1,
        }));

        setChats((prevChats) => {
          const exists = prevChats.find((c) => c._id === chatId);
          return exists
            ? reorderChats(prevChats, newMessage)
            : [newMessage.chat, ...prevChats];
        });

        // ✅ Show browser notification
        if (Notification.permission === "granted") {
          new Notification("New Message", {
            body: `${newMessage.sender.name}: ${newMessage.content}`,
          });
        }
      }
    });

    socket.on("new group created", (group) => {
      console.log("👥 New group received via socket:", group);
      setChats((prev) => {
        const alreadyExists = prev.find((c) => c._id === group._id);
        return alreadyExists ? prev : [group, ...prev];
      });
    });

    return () => {
      socket.off("message received");
      socket.off("new group created");
    };
  }, [selectedChat, chats, setChats, user, setMessages, setUnreadCounts]);

  return (
    <Box
      display={{ base: selectedChat ? "flex" : "none", md: "flex" }}
      alignItems="center"
      flexDirection="column"
      p={3}
      bg="white"
      w={{ base: "100%", md: "68%" }}
      borderRadius="lg"
      borderWidth="1px"
      h="100%"
    >
      <SingleChat fetchAgain={fetchAgain} setFetchAgain={setFetchAgain} />
    </Box>
  );
};

export default Chatbox;
